import moment from 'moment'

let template = `
<div>
  <div class="form-inline">
    <button class="btn btn-sm btn-default" ng-click="$ctrl.state.refreshImportStatus()" ng-disabled="$ctrl.state.fetchingImportRecordStatus || $ctrl.state.fetchingImportRecordCommit">Refresh Status</button>&nbsp;
    <div class="checkbox">
      <label>
        <input type="checkbox" ng-checked="$ctrl.state.autorefresh" ng-click="$ctrl.state.toggleAutorefresh()"> Autorefresh ({{$ctrl.state.autorefreshIntervalSeconds()}} seconds)
      </label>
    </div>

    <span class="text-muted">Last checked {{$ctrl.state.statusLastUpdated | readableTimestamp}}</span>
  </div>
  <br>
  <p><b>Current status:</b> {{$ctrl.state.importRecordStatus.status}} <br> <b>Last updated:</b> {{$ctrl.state.importRecordStatus.updated_at | readableTimestamp}}</p>

  <div ng-if="$ctrl.state.importRecordStatus.errors && $ctrl.state.importRecordStatus.errors.length > 0">
    <h4>Errors</h4>
    <ul>
      <li class="text-danger" ng-repeat="err in $ctrl.state.importRecordStatus.errors track by $index">{{err}}</li>
    </ul>
  </div>

  <h4>Status History <small>– <a ng-click="$ctrl.showHistory = !$ctrl.showHistory">{{$ctrl.showHistory && 'Hide' || 'Show'}}</a></small></h4>
  <div uib-collapse="!$ctrl.showHistory" class="max-height-overflow--500">
    <table class="table">
      <tr ng-repeat="log in $ctrl.state.importRecordStatus.status_log track by $index">
        <td>{{log.time | dateTimestampSeconds}}</td>
        <td>{{log.status}}</td>
      </tr>
    </table>
  </div>

</div>
`
export default {
  bindings: {
    importUuid: '@',
    showHistory: '='
  },
  controller: [
    'importState',
    '$scope',
    function(importState, $scope) {
      this.state = importState

      $scope.$on('$destroy', function() {
        console.log('import_status ctrl scope destroy')
        // cancel autorefresh if it's active
        if (importState.autorefresh) {
          importState.toggleAutorefresh()
        }
      })

      this.$onChanges = function(changesObj) {
        if (changesObj.importUuid && changesObj.importUuid.currentValue) {
          importState.refreshImportStatus(this.importUuid)
        }
      }
    }
  ],
  template
}
